import DiagnosisMaster from './DiagnosisMaster';
import SearchDiagnosis from './SearchDiagnosis';

const diagnosisComponents = {
    DiagnosisMaster,
    SearchDiagnosis
}

export default diagnosisComponents;